import React from 'react';
import ClosedCircleCheckIcon from '../../../../svgs/RentReportCheckIcon';
import ClosedCircleCancelIcon from '../../../../svgs/RentReportCancelIcon';

import RentReportingStyles from './RentReportingStatus.module.scss';

const RentReportingStatus = ({ activeRentReportingStatus }: { activeRentReportingStatus: any }) => {
  const tickIcon = activeRentReportingStatus ? (
    <ClosedCircleCheckIcon />
  ) : (
    <ClosedCircleCancelIcon />
  );

  return (
    <div className={RentReportingStyles.statusWrapper}>
      <div className={`${RentReportingStyles.statusWrapper__status} ${activeRentReportingStatus ? RentReportingStyles['statusWrapper__status--active'] : RentReportingStyles['statusWrapper__status--inactive']}`}>
        <div className={RentReportingStyles.statusWrapper__statusIcon}>{tickIcon}</div>
        <p className={RentReportingStyles.statusWrapper__statusText}>Rent reporting</p>
      </div>
    </div>
  );
};

export default RentReportingStatus;
